import Vue from 'vue'
import App from './App.vue'
import stores from './store/index'
import router from './router'
import ElementUI from 'element-ui'
import 'animate.css/animate.min.css'
import '@/content/css/element-variables.scss'
import '@/content/css/common.scss'
import '@/directives'
import 'swiper/dist/css/swiper.css'
import moment from 'moment'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueClipboard from 'vue-clipboard2'
moment.locale('zh-cn');

Vue.use(VueClipboard)
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI);

new Vue({
    el: '#app',
    router,
    store: stores,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./app/main.js